import { env } from "@/env";

export const MAX_FILE_SIZE = env.PUBLIC_MAX_FILE_SIZE;
export const MAX_TOTAL_FILES_SIZE = env.PUBLIC_MAX_TOTAL_FILES_SIZE;

export const MAX_FILE_SIZE_UPLOAD = MAX_FILE_SIZE! * 1024 * 1024;
export const MAX_TOTAL_FILES_SIZE_UPLOAD = MAX_TOTAL_FILES_SIZE! * 1024 * 1024;

/** Avatar images cap at 15MB (stricter than the generic attachment limit). */
export const AVATAR_MAX_FILE_SIZE = 15 * 1024 * 1024;
